import { ActionEnum } from "../action.enum";
import { Job } from "../../models/job/Job";
import { JobUpdateView } from "../../models/job/JobUpdateView";
import { JobStatus } from "../../enums/job/JobStatus";
import { DocumentModel } from "../../models/document/document.model";
import { ChecklistInfo } from '../../models/checklist/checklist-info.model';
import { JobFillOutAccordion } from './job-fill-out-accordion.enum';
import { AttributeCreationView } from '../../models/attribute/attribute-creation.model';

export namespace JobFillOutAction {

  export class Init {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_INIT;

    constructor(public jobId: string) {}
  }

  export class ReloadJob {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_RELOAD_JOB;

    constructor() {}
  }

  export class ReloadChecklists {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_RELOAD_CHECKLISTS;

    constructor() {}
  }

  export class AddChecklistInfoWithoutSave {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_ADD_CHECKLIST_INFO_WITHOUT_SAVE;

    constructor(public checklistInfo: ChecklistInfo) {}
  }

  export class RemoveChecklistInfoWithoutSave {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_REMOVE_CHECKLIST_INFO_WITHOUT_SAVE;

    constructor(public checklistTemplateId: string) {}
  }

  export class ShowAccordion {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_SHOW_ACCORDION;

    constructor(public accordion: JobFillOutAccordion, public editMode = false) {}
  }

  export class HideAccordion {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_HIDE_ACCORDION;

    constructor(public accordion: JobFillOutAccordion) {}
  }

  export class FocusAccordion {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_FOCUS_ACCORDION;

    constructor(public accordion: JobFillOutAccordion) {}
  }

  export class TogglePinned {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_TOGGLE_PINNED;

    constructor() {}
  }

  export class UpdateJobAssessment {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_ASSESSMENT;

    constructor(public updatedJob: Job) {}
  }

  export class UploadFile {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPLOAD_FILE;

    constructor(public file: File) {}
  }

  export class UploadFiles {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPLOAD_MULTIPLE_FILES;

    constructor(public files: File[]) {}
  }

  export class DeleteFile {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_DELETE_FILE;

    constructor(public file: DocumentModel) {}
  }

  export class SetJobStatus {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_SET_JOB_STATUS;

    constructor(
      public jobStatus: JobStatus,
      public shortenEndDateOfOutOfOrder?: boolean,
      public implDateStart?: number,
      public implDateEnd?: number,
      public allDayPlannedDate?: boolean
    ) {}
  }

  export class SaveJob {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_SAVE_JOB;
  }

  export class AutoSave {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_AUTO_SAVE;
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_RESET_STATE;
    constructor(public keepFillOutLock: boolean = false) {}
  }

  export class JobOutOfJobCreated {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_JOB_OUT_OF_JOB_CREATED;
    constructor(public jobId: string) {
    }
  }

  export class UpdateJobInfos {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_INFOS;

    constructor(public job: JobUpdateView) {}
  }

  export class UpdateJobInfosFromFillOutPage {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_INFOS_FROM_FILL_OUT_PAGE;

    constructor(public updatedJob: Job) {}
  }

  export class RescheduleAppointment {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_RESCHEDULE_APPOINTMENT;

    constructor(public job: JobUpdateView) {}
  }

  export class UpdateJobTime {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_TIME;

    constructor(public updatedJob: Job) {}
  }

  export class UpdateJobSchedule {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_SCHEDULE;

    constructor(public updatedJob: Job) {}
  }

  export class UpdateJobDetails {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_DETAILS;

    constructor(public attributes: AttributeCreationView[]) {}
  }

  export class ReloadChatCounts {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_RELOAD_CHAT_COUNTS;
  }

  export class UpdateJobDescription {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_DESCRIPTION;
    constructor(public jobId: string, public description: string) {}
  }

  export class UpdateJobDescriptionDraft {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_DESCRIPTION_DRAFT;
    constructor(public description: string) {}
  }

  export class UpdateServiceProviderNoteDraft {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_SERVICE_PROVIDER_NOTE_DRAFT;
    constructor(public serviceProviderNote: string) {}
  }

  export class UpdateJobDescriptionSuccess {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_DESCRIPTION_SUCCESS;
    constructor(public jobId: string, public description: string) {}
  }

  export class UpdateJobDescriptionFailure {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_DESCRIPTION_FAILURE;
    constructor(public error: any) {}
  }

  export class UpdateJobMessages {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UPDATE_JOB_MESSAGES;
    constructor(public newMessageIds: string[] = [], public removedMessageIds: string[] = []) {}
  }

  export class RegisterActiveFillingOutUser {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_REGISTER_ACTIVE_FILLING_OUT_USER;
    constructor() {}
  }

  export class UnregisterActiveFillingOutUser {
    static readonly type: ActionEnum = ActionEnum.JOB_FILL_OUT_UNREGISTER_ACTIVE_FILLING_OUT_USER;
    constructor() {}
  }
}
